import React from 'react';

function PrivacyActStatement() {
  return (
    <>
      <p data-testid="privacy-act-notice">
        The VA will not disclose information collected on this form to any
        source other than what has been authorized under the Privacy Act of 1974
        or title 38, Code of Federal Regulations, section 1.576 for routine uses
        (i.e., civil or criminal law enforcement, congressional communications,
        epidemiological or research studies, the collection of money owed to the
        United States, litigation in which the United States is a party or has
        an interest, the administration of VA programs and delivery of VA
        benefits, verification of identity and status, and personnel
        administration as identified in the VA system of records, 58VA21/22/28,
        Compensation, Pension, Education, and Veteran Readiness and Employment
        Records - VA, and published in the Federal Register. Your obligation to
        respond is voluntary. VA uses your SSN to identify your claim file.
        Providing your SSN will help ensure that your records are properly
        associated with your claim file. Giving us your SSN account information
        is voluntary. Refusal to provide your SSN by itself will not result in
        the denial of benefits. The VA will not deny an individual benefits for
        refusing to provide his or her SSN unless the disclosure of the SSN is
        required by Federal Statute of law effect prior to January 1, 1975, and
        still in effect.
      </p>
    </>
  );
}

export default PrivacyActStatement;
